import { basementAjax } from "@/common/ajax.js";
import { Message } from "element-ui";

// 会话级幂等标志：不放入 state，避免被 vuex-persistedstate 持久化，
// 从而保证每次刷新页面（JS 重新加载）都会重置并重新请求一次。
let defaultBelongFetched = false;

const variable = {
  state: {
    hasNav:true,
    baseColor:'blue',
    // 图纸默认使用地点：'1'=上海 '2'=苏州 '3'=合肥（存字符串以匹配 el-radio 的 label）
    defaultBelong: '1',
  },
  mutations: {
    UPDATEHASNAV: (state, data) => {
      state.hasNav = data;
    },
    UPDATEBASECOLOR: (state, data) => {
      state.baseColor = data;
    },
    UPDATEDEFAULTBELONG: (state, data) => {
      state.defaultBelong = data;
    },
  },
  actions: {
    updateHasNav({ commit }, data) {
      commit("UPDATEHASNAV", data);
    },
    updateBaseColor({ commit }, data) {
      commit("UPDATEBASECOLOR", data);
    },
    // 请求当前用户常驻站点并写入 Vuex；首次登录后与每次刷新页面请求一次（会话内幂等）；返回归属地字符串，失败返回 null
    fetchDefaultBelong({ commit, state }) {
      if (defaultBelongFetched) {
        return Promise.resolve(state.defaultBelong);
      }
      defaultBelongFetched = true;
      return new Promise((resolve) => {
        const reset = () => {
          defaultBelongFetched = false;
        };
        basementAjax(
          null,
          "/techik/workOrderDrawingWebDav/resolveBelong",
          {},
          (res) => {
            const data = res && res.data ? res.data.data : null;
            // 后端返回 { belong, configured }
            const belong = data ? data.belong : null;
            const configured = data ? data.configured : false;
            const val = belong != null ? String(belong) : '1';
            commit("UPDATEDEFAULTBELONG", val);
            // 未配置常驻地时提示用户联系IT补充
/*            if (!configured) {
              Message({
                message: '未配置常驻站点，当前默认按上海处理，请尽快联系 IT 补充常驻地',
                type: 'warning',
                duration: 6000,
              });
            }*/
            resolve(val);
          },
          () => { reset(); resolve(null); },
          () => { reset(); resolve(null); },
          () => { reset(); resolve(null); },
        );
      });
    },
  },
  getters: {
    hasNav: state => {
      return state.hasNav;
    },
    baseColor: state => {
      return state.baseColor;
    },
    defaultBelong: state => {
      return state.defaultBelong;
    },
  },
};
export default variable;



// WEBPACK FOOTER //
// ./src/store/mutations/variable.js